module.exports = __webpack_public_path__ + "static/media/first-aid.09049261.svg";